import { activitylogapi } from "./activitylogapi";
import { clientapi } from "./clientsapi";
import { clientsService } from "./clientsService";
import { consentForm } from "./consentForm";
import { dashboardapi } from "./dashboardapi";
import { draftapi } from "./draftapi";
import { medicinegroup } from "./medicinegroup";
import { medicinesapi } from "./medicinesapi";
import { postsessioninstruction } from "./postsessioninstruction";
import { prescriptionapi } from "./prescriptionapi";
import { presessioninstruction } from "./presessioninstruction";
import { rolepermissions } from "./rolepermissionapi";
import { servicesService } from "./servicesService";
import { sessionapi } from "./sessionapi";
import { sessionsService } from "./sessionsService";
import { templateapi } from "./templateapi";
import { userapi } from "./userapi";
export const services = {
  dashboardapi,
  clientapi,
  servicesService,
  clientsService,
  sessionsService,
  presessioninstruction,
  postsessioninstruction,
  consentForm,
  sessionapi,
  medicinegroup,
  medicinesapi,
  templateapi,
  draftapi,
  rolepermissions,
  userapi,
  activitylogapi,
  prescriptionapi,
};
